/* eslint-disable no-underscore-dangle */

/* eslint-disable react/jsx-no-bind, consistent-return */

import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import i18n from 'i18next';
import L from 'leaflet';
import HTMLReactParser from 'html-react-parser/lib/index';
import { GetOutputAPI, getPopups, GetRedOutputAPI, sendNotification, saveLocation } from '../../API/api';
import logoPic from '../../assets/designSystem/logo/symbol-default.svg';
import GeoPermissionModal from '../../components/GeolocationModal';
import houseIcon from '../../assets/designSystem/icons/output/house.svg';
import hospitalIcon from '../../assets/designSystem/icons/output/hospital.svg';
import warningIcon from '../../assets/designSystem/icons/output/warning-2.svg';
import dangerIcon from '../../assets/designSystem/icons/output/danger.svg';
// import phone from '../../assets/designSystem/icons/icon_phone.png';
import './Output.css';
import OutputSection from '../../components/OutputSection/OutputSection';
import {
  returnDate,
  getGeolocationPermissionState,
  getUserLocation,
  persistUserLocation,
  requestCurrentLocation,
  reverseGeocode,
  storeResolvedLocationData,
} from '../../utils/index';
import Paracetamol from './PopUp/paracetamol';
import Fluids from './PopUp/fluids';
import MalariaAreas from './PopUp/malariaAreas';
import Ambulance from './PopUp/ambulance';
import BreathingQuickly from './PopUp/breathingQuickly';
import Eye from './PopUp/eye';
import ColdOrEar from './PopUp/coldOrEar';
import Cough from './PopUp/cough';
import Diarrhoea from './PopUp/diarrhoea';
import AbnormalMovement from './PopUp/abnormalMovement';
import Ibuprofen from './PopUp/ibuprofen';
import Ors from './PopUp/ors';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';
import MetricsContext from '../../context/MetricsContext';
import Popup from './PopUp/Popup';
import { PermissionsState } from '../../utils/common';
import Nav from '../../components/Nav/Nav';
import { ensureNotificationSubscription } from '../../utils/notifications';
import Button from '../../components/Button/Button';
import ButtonNames from '../../utils/ButtonNames';

function Output() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [outputNumber, setOutputNumber] = useState(0);
  const [outputSectionsArray, setoutputSectionsArray] = useState([]);
  const [popup, setPopup] = useState([{}]);
  const [popups, setPopups] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showparacetamol, setShowparacetamol] = useState(false);
  const [showFluids, setShowFluids] = useState(false);
  const [showAmbulance, setShowAmbulance] = useState(false);
  const [showBreathing, setShowBreathing] = useState(false);
  const [showMalariaAreas, setShowMalariaAreas] = useState(false);
  const [showeye, setShoweye] = useState(false);
  const [showColdOrEar, setShowColdOrEar] = useState(false);
  const [showCough, setShowCough] = useState(false);
  const [showDiarrhoea, setShowDiarrhoea] = useState(false);
  const [showAbnormalMovement, setShowAbnormalMovement] = useState(false);
  const [showOrs, setShowOrs] = useState(false);
  const [showIbuprofen, setShowIbuprofen] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [geoPermissionState, setGeoPermissionState] = useState(PermissionsState.UNKNOWN);
  const params = location.state?.answers.split('.').slice(1).join('.');
  const symptom = location.state?.symptom;
  const ageGroup = location.state?.answers.split('.')[0][0];
  const babyOrChild = ageGroup < 4 ? 'baby' : 'child';
  // const [completedJourneyId, setCompletedJourneyId] = useState('');
  const [showGeoModal, setShowGeoModal] = useState(false);
  const mapRef = useRef(null);
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');

  const { language } = i18n;
  const { updateUserMetric } = useContext(MetricsContext);
  const startDate = new Date();

  async function showNotification(researchId, outputType) {
    try {
      const subscription = await ensureNotificationSubscription();

      if (!subscription) {
        return;
      }

      const sub = {
        subscription,
        researchId,
        outputType,
        language,
      };

      sendNotification(sub);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error during notification setup:', error);
    }
  }

  useEffect(() => {
    async function checkPermissions() {
      const permissionState = await getGeolocationPermissionState();
      setGeoPermissionState(permissionState);
      setShowGeoModal(permissionState === PermissionsState.DENIED);
    }
    checkPermissions().catch(() => {
      setGeoPermissionState(PermissionsState.UNKNOWN);
      setShowGeoModal(false);
    });
  }, []);

  async function getFacilities(latitude, longitude) {
    const url = `https://overpass-api.de/api/interpreter?data=[out:json];node["amenity"="hospital"](around:5000,${latitude},${longitude});out;`;
    const response = await fetch(url);
    const data = await response.json();
    return data.elements;
  }

  const initializeMap = async (latitude, longitude) => {
    try {
      const mapElement = document.getElementById('map');
      if (!mapElement) {
        throw new Error('Map container not found');
      }

      if (mapRef.current) {
        mapRef.current.remove();
      }

      const map = L.map(mapElement).setView([latitude, longitude], 15);
      mapRef.current = map;

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(map);

      const customIcon = L.icon({
        iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        shadowSize: [41, 41],
      });

      const userMarker = L.marker([latitude, longitude], { icon: customIcon }).addTo(map);
      userMarker.bindPopup('You are here!').openPopup();

      const facilities = await getFacilities(latitude, longitude);
      facilities.forEach((facility) => {
        const marker = L.marker([facility.lat, facility.lon], { icon: customIcon }).addTo(map);
        marker.bindPopup(facility.tags.name || 'Hospital');
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error initializing map: ${error.message}`);
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem('sessionId');
    async function fetchOutput() {
      getPopups().then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setPopups(data);
          });
        }
      });
      if (location.state?.redAnswer === true) {
        const data = await GetRedOutputAPI(params, userId);
        const response = await data.json();
        if (!data.ok) {
          navigate('/error', {
            state: { code: data.status, message: JSON.stringify(response) },
          });
        } else {
          setOutputNumber(response.outputType);
          setoutputSectionsArray(response.outputSections);
          if (response.completedJourneyId) {
            showNotification(response.completedJourneyId, response.outputType);
            // setCompletedJourneyId(response.completedJourneyId);
          }
        }
        setLoading(false);
      } else {
        const data = await GetOutputAPI(params, userId);
        const response = await data.json();

        if (!data.ok) {
          navigate('/error', {
            state: { code: data.status, message: JSON.stringify(response) },
          });
        } else {
          setOutputNumber(response.outputType);
          setoutputSectionsArray(response.outputSections);
          if (response.completedJourneyId) {
            showNotification(response.completedJourneyId, response.outputType);
            // setCompletedJourneyId(response.completedJourneyId);
          }
        }
        setLoading(false);
      }
    }
    fetchOutput();
  }, []);

  const outputTypes = {
    0: 'green',
    1: 'yellow',
    2: 'orange',
    3: 'red',
  };

  useEffect(() => {
    updateUserMetric(
      {
        name: PageNames.OUTPUT_PAGE,
        pageType: PageTypes.OUTPUT_METRIC,
        outputSectionsTotal: outputNumber,
        outputSectionsCount: outputSectionsArray.length,
      },
      {
        algorithmData: {
          outputsList: outputSectionsArray,
          outputType: outputTypes[outputNumber],
          questionsList: (() => {
            const ql = localStorage.getItem('questionsList');
            if (!ql) return [];
            try {
              return typeof ql === 'string' ? JSON.parse(ql) : ql;
            } catch {
              return [];
            }
          })(),
        },
      }
    );
  }, [outputNumber]);

  useEffect(() => {
    const setupLocation = async () => {
      try {
        let locationData = getUserLocation();
        let geocodeData = null;

        if (!locationData) {
          const permissionState = await getGeolocationPermissionState();
          setGeoPermissionState(permissionState);
          setShowGeoModal(permissionState === PermissionsState.DENIED);

          if (permissionState !== PermissionsState.DENIED && permissionState !== PermissionsState.UNSUPPORTED) {
            try {
              const position = await requestCurrentLocation();
              const persistedLocation = await persistUserLocation(position);
              locationData = persistedLocation.coordinates;
              geocodeData = persistedLocation.data;
              setGeoPermissionState(PermissionsState.GRANTED);
              setShowGeoModal(false);
            } catch (locationError) {
              const refreshedPermissionState = await getGeolocationPermissionState();
              setGeoPermissionState(refreshedPermissionState);
              setShowGeoModal(refreshedPermissionState === PermissionsState.DENIED);
              throw locationError;
            }
          }
        }

        if (!locationData) {
          throw new Error('No user location found');
        }

        setCurrentLocation(locationData);

        const data = geocodeData || (await reverseGeocode(locationData.latitude, locationData.longitude));
        if (!data?.address) {
          throw new Error('Reverse geocoding failed');
        }

        const { county } = storeResolvedLocationData(data);

        if (county) {
          await saveLocation({
            county,
            subcounty: data.address.county,
            symptom,
            output: outputNumber,
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error in location setup: ${error.message}`);
      }
    };

    setupLocation();
  }, [outputNumber, symptom]);

  useEffect(() => {
    if (
      (outputNumber === 2 || outputNumber === 3) &&
      localStorage.getItem('country') === 'Kenya' &&
      currentLocation?.latitude &&
      currentLocation?.longitude
    ) {
      const timerId = window.setTimeout(() => {
        initializeMap(currentLocation.latitude, currentLocation.longitude);
      }, 0);

      return () => {
        window.clearTimeout(timerId);
      };
    }

    return undefined;
  }, [currentLocation, outputNumber]);

  useEffect(
    () => () => {
      if (mapRef.current) {
        mapRef.current.remove();
      }
    },
    []
  );
  const outputs = [
    {
      color: 'output__green',
      icon: houseIcon,
      title: `Your ${babyOrChild} can stay at home`,
      description: `If your ${babyOrChild} worsens, does not improve or you get more worried, contact a Community Health Promoter (CHP) or visit a health center.`,
    },
    {
      color: 'output__yellow',
      icon: warningIcon,
      title: 'Monitor',
      description: 'Watch out for any changes. Contact a Community Health Promoter (CHP) within the next 24 hours.',
    },
    {
      color: 'output__orange',
      icon: dangerIcon,
      title: 'Attention',
      description: `Take your ${babyOrChild} to the nearest health facility as soon as possible.`,
    },
    {
      color: 'output__red',
      icon: hospitalIcon,
      title: 'Emergency',
      description: `Your ${babyOrChild} may be very unwell. Take them to the nearest health facility NOW. Do not delay. If necessary, call an ambulance on <a href="tel:0800721316">0800 721316</a> (toll free)`,
    },
  ];
  const renderoutputitle = () => {
    const type = outputTypes[outputNumber];
    switch (type) {
      case 'green':
        return <h3 className="output__header__title green">{t(`output.green.${babyOrChild}.title`)}</h3>;
      case 'yellow':
        return <h3 className="output__header__title monitor">{t(`output.title.${babyOrChild}.title`)}</h3>;
      case 'orange':
        return <h3 className="output__header__title attention">{t('output.orange.title')}</h3>;
      case 'red':
        return <h3 className="output__header__title emergency">{t('output.red.title')}</h3>;
      default:
        return null;
    }
  };

  const renderoutputp = () => {
    switch (outputNumber) {
      case 0:
        return <p className="small">{t(`output.green.${babyOrChild}.description`)}</p>;
      case 1:
        return <p className="small">{t('output.yellow.description')}</p>;
      case 2:
        return <p className="small">{t(`output.orange.${babyOrChild}.description`)}</p>;
      case 3:
        return <p className="small">{HTMLReactParser(t(`output.red.${babyOrChild}.description`))}</p>;
      default:
        break;
    }
  };

  const updateMetrics = (actionName) => {
    const dateFinal = new Date();
    updateUserMetric({
      name: PageNames.OUTPUT_PAGE,
      pageType: PageTypes.OUTPUT_METRIC,
      duration: Math.abs(dateFinal - startDate),
      interactions: [
        {
          name: actionName,
          time: new Date(),
        },
      ],
    });
  };

  const handleNewAssessmentBtn = () => {
    updateMetrics(ButtonNames.CONTINUE_NEW);
    navigate('/assessment');
  };

  // const handleContinueBtn = () => {
  //   updateMetrics(ButtonNames.CONTINUE);
  //   navigate('/feedback', {
  //     state: {
  //       completedJourneyId,
  //     },
  //   });
  // };

  function handleRedirectParacetamol() {
    setShowparacetamol(!showparacetamol);
  }

  function handleRedirectFluids() {
    setShowFluids(!showFluids);
  }

  function handleRedirectAmbulance() {
    setShowAmbulance(!showAmbulance);
  }

  function handleRedirectBreathingQuickly() {
    setShowBreathing(!showBreathing);
  }

  function handleRedirectDiarrhoea() {
    setShowDiarrhoea(!showDiarrhoea);
  }

  function handleRedirectCough() {
    setShowCough(!showCough);
  }

  function handleRedirectColdorearsymptoms() {
    setShowColdOrEar(!showColdOrEar);
  }

  function handleRedirectAbnormalmovements() {
    setShowAbnormalMovement(!showAbnormalMovement);
  }

  function handleRedirectEyes() {
    setShoweye(!showeye);
  }

  function handleRedirectMalaria() {
    setShowMalariaAreas(!showMalariaAreas);
  }

  function handleRedirectOrs() {
    setShowOrs(!showOrs);
  }

  function handleRedirectIbuprofen() {
    setShowIbuprofen(!showIbuprofen);
  }

  function handlePopup(val) {
    updateMetrics(`Popup: ${val}`);
    const popupObj = popups.find((popup) => popup.name === val && popup.language === language);
    if (popupObj !== undefined) {
      setPopup(popupObj);
      setOpenPopup(true);
    } else {
      switch (val) {
        case 'paracetamol':
          handleRedirectParacetamol();
          break;
        case 'fluids':
          handleRedirectFluids();
          break;
        case 'malaria':
          handleRedirectMalaria();
          break;
        case 'cough':
          handleRedirectCough();
          break;
        case 'coldorear':
          handleRedirectColdorearsymptoms();
          break;
        case 'diarrhoea':
          handleRedirectDiarrhoea();
          break;
        case 'ors':
          handleRedirectOrs();
          break;
        case 'eye':
          handleRedirectEyes();
          break;
        case 'breathingquickly':
          handleRedirectBreathingQuickly();
          break;
        case 'abnormal':
          handleRedirectAbnormalmovements();
          break;
        case 'ambulance':
          handleRedirectAmbulance();
          break;
        case 'ibuprofen':
          handleRedirectIbuprofen();
          break;
        default:
          break;
      }
    }
  }

  return (
    <>
      {loading && (
        <div className="loadingPage__content">
          <div className="loadingPage__animation">
            <span style={{ '--n': 1, background: 'var(--feedback-colors-yellow)' }} />
            <span style={{ '--n': 2, background: 'var(--feedback-colors-yellow)' }} />
            <span style={{ '--n': 3, background: 'var(--feedback-colors-orange)' }} />
            <span style={{ '--n': 4, background: 'var(--feedback-colors-orange)' }} />
            <span style={{ '--n': 5, background: 'var(--feedback-colors-red)' }} />
            <span style={{ '--n': 6, background: 'var(--feedback-colors-red)' }} />
            <span style={{ '--n': 7, background: 'var(--brand-colors-primary-3)' }} />
            <span style={{ '--n': 8, background: 'var(--brand-colors-primary-3)' }} />
          </div>
        </div>
      )}
      {!loading && (
        <>
          <Nav sidebar onVersionChange={setActiveVersion} />
          <div className="outputContainer">
            <div className="containerContent output__container">
              <div className={`output__header ${outputs[outputNumber].color}`}>
                <img src={outputs[outputNumber].icon} alt="icon" width="64" height="64" />
                {renderoutputitle()}
                <p className="small output__header__p">
                  <span>{returnDate()} - </span>
                  {t(`symptompage.${symptom}`)}
                </p>
                {renderoutputp()}
                {/* {outputNumber === 3 && (
                  <a href="tel:0800721316" className="phone__btn__button" onClick={handleCall}>
                    <span>
                      <img src={phone} alt="phone icon" />
                    </span>
                    <span>
                      <p className="phone__btn__number">{t('popUps.ambulance.number1')}</p>
                    </span>
                  </a>
                )} */}
              </div>
              <div className="output__content">
                <div className="output__outputSections">
                  {outputSectionsArray?.map(
                    (sectiondata) =>
                      sectiondata !== null && (
                        <OutputSection key={sectiondata._id} data={sectiondata} callback={handlePopup} />
                      )
                  )}
                </div>
                {(outputNumber === 2 || outputNumber === 3) && localStorage.getItem('country') === 'Kenya' && (
                  <div id="map" />
                )}
                <div className="output__card">
                  <img src={logoPic} alt="icon" width="40" height="20" />
                  <p className="output__card__p">{t(`output.${babyOrChild}.outputcardp`)}</p>
                  <Button width="fullWidth" hierarchy="secondary" onClick={handleNewAssessmentBtn}>
                    {t('output.restart')}
                  </Button>
                </div>
                {/* <div className="output__button">
                  <Button width="fullWidth" hierarchy="primary" onClick={handleContinueBtn}>
                    {t('continue')}
                  </Button>
                </div> */}
                <p className="output__p">
                  {t(`output.${babyOrChild}.outputp1`)}
                  <br />
                  <br />
                  {t(`output.${babyOrChild}.outputp2`)}
                </p>
              </div>
            </div>
          </div>
          {openPopup && (
            <Popup
              title={popup.title}
              text={popup.text}
              tableData={popup.tableData}
              callback={() => {
                setOpenPopup(false);
                setPopup({});
              }}
            />
          )}
          {showparacetamol && <Paracetamol babyOrChild={babyOrChild} callback={handleRedirectParacetamol} />}
          {showFluids && <Fluids callback={handleRedirectFluids} />}
          {showAmbulance && <Ambulance callback={handleRedirectAmbulance} />}
          {showBreathing && <BreathingQuickly babyOrChild={babyOrChild} callback={handleRedirectBreathingQuickly} />}
          {showAbnormalMovement && (
            <AbnormalMovement babyOrChild={babyOrChild} callback={handleRedirectAbnormalmovements} />
          )}
          {showeye && <Eye babyOrChild={babyOrChild} callback={handleRedirectEyes} />}
          {showDiarrhoea && <Diarrhoea babyOrChild={babyOrChild} callback={handleRedirectDiarrhoea} />}
          {showColdOrEar && <ColdOrEar babyOrChild={babyOrChild} callback={handleRedirectColdorearsymptoms} />}
          {showCough && <Cough babyOrChild={babyOrChild} callback={handleRedirectCough} />}
          {showMalariaAreas && <MalariaAreas callback={handleRedirectMalaria} />}
          {showOrs && <Ors callback={handleRedirectOrs} />}
          {showIbuprofen && <Ibuprofen babyOrChild={babyOrChild} callback={handleRedirectIbuprofen} />}
        </>
      )}
      {showGeoModal && (
        <GeoPermissionModal permissionState={geoPermissionState} onClose={() => setShowGeoModal(false)} />
      )}
    </>
  );
}

export default Output;
